// src/services/httpService.js
import Swal from 'sweetalert2';
import config from '../config/config';

export const signup = async (formData, reset, openDialog) => {

    try {
        // Sending POST request to signup endpoint
        const response = await fetch(`${config.apiBaseUrl}${config.endpoints.Signup}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(formData)
        });

        const data = await response.json();

        if (data.success) {
            // Successful signup
            const loginData = {
                email: formData.email,
                password: formData.password,
            };
            if (reset) {
                reset();
            }
            if (openDialog) {
                openDialog('signupsuccess');
            }

            // Login after successful signup
            const loginResponse = await fetch(`${config.apiBaseUrl}${config.endpoints.Login}`, {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(loginData)
            });

            const resp = await loginResponse.json();

            if (resp.success) {
                localStorage.setItem("jwt", resp.data.access_token);
                localStorage.setItem("user", JSON.stringify(resp.data));
                localStorage.setItem("userId", JSON.stringify(resp.data.company_id));

                // Update the global authentication context (if needed)
                // setAuth({
                //     isAuthenticated: true,
                //     user: loginData.data,
                // });

                // Redirect to dashboard or home page
                //history.push('/dashboard'); // Adjust route as per your app

                console.log({ message: 'Signup and login successful', type: 'success' });
            } else {
                // Handle login error message (show toast)
                console.log({ message: loginData.error?.msg || 'Login failed after signup', type: 'error' });
            }
        } else {
            // Handle signup error message (show toast)
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: data.msg || 'Signup failed',
            });
            console.log({ message: data.error?.msg || 'Signup failed', type: 'error' });
        }

        return data;
    } catch (error) {
        console.error("Error during signup:", error);
        throw error; // Rethrow the error for further handling
        console.log({ message: 'Something went wrong, please try again.', type: 'error' });
    } finally {
        console.log("Api call");
    }
};

export const login = async () => {
    const requestData = {

    };

    try {
        const response = await fetch(`${config.apiBaseUrl}${config.endpoints.Login}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(requestData)
        });

        const data = await response.json();

        if (response.ok) {
            // Successful login
            localStorage.setItem("jwt", data.data.access_token);
            localStorage.setItem("user", JSON.stringify(data.data));
            localStorage.setItem("userId", JSON.stringify(data.data.company_id));

            // Update the global authentication context (you can adjust based on your context setup)
            // setAuth({
            //   isAuthenticated: true,
            //   user: data.data
            // });

            // Redirect to dashboard or home page
            //history.push('/dashboard'); // Adjust route as per your app

            console.log({ message: 'Login successful', type: 'success' });
        } else {
            // Handle error message (show toast)
            console.log({ message: data.error?.msg || 'Login failed', type: 'error' });
        }

        return data;
    } catch (error) {
        console.error("Error fetching clients:", error);
        throw error; // Rethrow the error for further handling
        console.log({ message: 'Something went wrong, please try again.', type: 'error' });
    } finally {
    }
};

export const contactUs = async (requestData, reset, openDialog) => {
    try {
        const response = await fetch(`${config.apiBaseUrl}${config.endpoints.ContactUs}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(requestData)
        });

        const data = await response.json();
        if (response.ok) {
            if (reset) {
                reset();
            }
            if (openDialog) {
                openDialog('thankyoucontactus');
            }
            console.log({ message: 'ContactUs successful', type: 'success' });
        } else {
            console.log({ message: data.error?.msg || 'From submit failed', type: 'error' });
        }

        return data;
    } catch (error) {
        console.log({ message: 'Something went wrong, please try again.', type: 'error' });
        throw error; // Rethrow the error for further handling
    } finally {
        console.log({ message: 'ContactUs api is call.', type: 'error' });
    }
};
export const bookADemo = async (requestData, reset, openDialog) => {
    try {
        const response = await fetch(`${config.apiBaseUrl}${config.endpoints.BookDemo}`, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(requestData)
        });

        const data = await response.json();
        if (response.ok) {
            if (reset) {
                reset();
            }
            if (openDialog) {
                openDialog('thankyou');
            }
            console.log({ message: 'BookDemo successful', type: 'success' });
        } else {
            console.log({ message: data.error?.msg || 'From submit failed', type: 'error' });
        }

        return data;
    } catch (error) {
        console.log({ message: 'Something went wrong, please try again.', type: 'error' });
        throw error; // Rethrow the error for further handling
    } finally {
        console.log({ message: 'ContactUs api is call.', type: 'error' });
    }
};